import React, {useEffect, useState} from "react";
import {Controller, useForm} from "react-hook-form";


import {
    StyleSheet,
    Text,
    View,
} from "react-native";
import {Button} from "../../../components/core/Button";
import {globalFontStyle} from "../../../assets";
import Colors from "../../../assets/Color/Colors";
import {isMobile, RegEx, trackMoengageEvent} from "../../../utils/commonMethods";

import {globalImport} from "../../../common/globalImports";
import OTPTextView from "../../../commonComponents/OtpComp";
import useTimer from "../../../commonComponents/useTimer";
import {Network} from "../../../utils/network";
import ShowError from "../../../common/ShowError";
import {Input} from "../../../components/core/Input";
import {setLoaderVisibility} from "../../../utils/commonredux/commonRedux.action";
import {useDispatch} from "react-redux";
import EmailBottomSheet from "./EmailBottomSheet";

function EmailEnterSheet({mobileEmailSheet, setMobileEmailSheet}) {

    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [otpScreen, setOtpScreen] = useState(false);

    const {
        watch,
        formState: { errors, isValid, dirtyFields },
        control,
        setError: setErrorForm,
    } = useForm({ mode: "onChange" });

    const watchEmail = watch("Email");

    const onVerifyClick = async (e) => {
        e.preventDefault();
        const reqobj = {
            email: watchEmail,
        };
        dispatch(setLoaderVisibility(true));
        trackMoengageEvent("Email OTP sent", {
            Email: watchEmail,
        });

        const res = await Network.sendOTPVerifyEmail(reqobj);

        if (res?.data?.success === "true") {
            setOtpScreen(true);
        } else {
            if (typeof res?.data?.error === "string") {
                setError({
                    val: "Retry",
                    message: res?.data?.error,
                    errorClass: { color: Colors.red },
                    borderColor: Colors.red
                });
            } else {
                setError({
                    val: "Retry",
                    message: "Some error occurred",
                    errorClass: { color: Colors.red },
                    borderColor: Colors.red
                });
            }
        }
        dispatch(setLoaderVisibility(false));
    };


    return (
        <>
        {otpScreen ? (
            <EmailBottomSheet
                email={watchEmail}
                mobileEmailSheet={mobileEmailSheet}
                setMobileEmailSheet={setMobileEmailSheet}
            />)
        :(<View
            style={{
                paddingTop: 20,
                height: "100%",
            }}>
            <View style={{paddingHorizontal: 16}}>
                <Text
                    style={{
                        ...globalFontStyle.appFontTitle,
                        color: Colors?.black,
                        paddingBottom: 5,
                    }}>
                    { "Enter your email"}
                </Text>
                {/*{showMobVerify !== 'Add Funds' && (*/}
                <Text
                    style={{
                        ...globalFontStyle.appFontHeadingRegular,
                        color: Colors?.lightgrey,
                        paddingBottom: 25,
                    }}>
                    {mobileEmailSheet === 'email'
                        ? "Please enter your email which you want to link with your TradeX account"
                        : "Please enter your phone number which you want to link with your TradeX account"}
                </Text>
                {/*)}*/}
                <Input
                    name="Email"
                    control={control}
                    variant="default"
                    size="default"
                    hideError={true}
                    rules={{
                        required: "Please enter email",
                        pattern: {
                            value: RegEx.email,
                            message: "Please enter a valid email",
                        },
                    }}
                />
                {(errors?.Email?.type === "required" || errors?.Email?.type === "pattern") && (
                    <ShowError error={{
                        val: "Retry",
                        message: errors?.Email.message,
                        errorClass: { color: Colors.red },
                        borderColor: Colors.red
                    }} />
                )}
                {error !== null && error?.message !== "" && error?.message !== errors?.Email?.message && (
                    <ShowError error={error} />
                )}
            </View>

            <View
                style={{
                    marginTop: 20,
                    paddingBottom: 15,
                    marginHorizontal: 16,
                }}>
                <Button
                    variant={isValid ? "primary" : "disabled"}
                    disabled={!isValid}
                    onPress={onVerifyClick}
                    style={{ flex: globalImport.isWeb ? {} : 0 }}
                >
                    Confirm
                </Button>
            </View>
        </View>)}
    </>
    );
}

export default EmailEnterSheet;

const styles = StyleSheet.create({
    inputDiv: {
        flexDirection: "row",
        marginBottom: 16,
        paddingLeft: 0,
        borderRadius: 8,
        alignItems: "center",
        borderColor: Colors.borderColor,
        borderWidth: 1,
    },
});
